import api from "./ApiURLBase";
const EndPointLogin = async data => {
  const result = await api.post(`/auth/login`, data);
  return result;
};

export { EndPointLogin };
